// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M20.52 2H3.48C2.66 2 2 2.64 2 3.43v17.14c0 .79.66 1.43 1.48 1.43h17.04c.82 0 1.48-.64 1.48-1.43V3.43C22 2.64 21.34 2 20.52 2ZM5.1 18.74v-9h2.99v9h-3ZM6.59 8.5h-.03c-1 0-1.65-.69-1.65-1.55 0-.88.67-1.56 1.7-1.56 1.02 0 1.65.68 1.67 1.56 0 .86-.65 1.55-1.7 1.55Zm12.28 10.24h-3v-4.82c0-1.2-.43-2.03-1.5-2.03-.84 0-1.33.55-1.54 1.09-.08.2-.1.46-.1.73v5.03h-3s.04-8.16 0-9h3V11a2.97 2.97 0 0 1 2.7-1.49c1.96 0 3.44 1.29 3.44 4.06v5.16Z" />
  </BaseIcon>
)
